<template>
  <div :id="id" class="radioButtonGroupContainer">
    <div v-for="(option,index) in options" :key="index">
      <input :id="id+'-'+index" type="radio" :name="id" :disabled="option.disabled == 1 || disabled" :checked="option.value === value" @change="radioOptionUpdated(option.value)">
      <label :id="id+'-'+index+'-Label'" :for="id+'-'+index" class="radio-option" :class="[option.disabled ? 'radio-disabled' : '']">
        {{ option.label }}
      </label>
    </div>
  </div>
</template>

<script>
export default {
  name: 'VpRadioButtons',
  props: {
    id: {
      type: String,
      default: '',
    },
    value: {
      type: [String, Boolean],
      default: '',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    options: {
      type: Array,
      default: () => [],
    },
  },
  emits: ['input'],
  created() {},
  mounted() {},
  methods: {
    radioOptionUpdated: function radioOptionUpdated(value) {
      this.$emit('input', value);
    },
  },
};
</script>

<style lang="scss" scoped>
@import '../../styles/colors.scss';

input[type=radio] {
 height:22px;
 width:22px;
}

input[type=radio]:disabled  {
 cursor: not-allowed;
}

label.radio-option {
 color:$charcoal;
 cursor:pointer;
 font-size:16px;
 line-height:24px;
 padding-left:12px;
 user-select:none;
 vertical-align:top;
}

label.radio-disabled {
 color: $gray;
 cursor: not-allowed;
}
</style>
